import { Star } from "lucide-react";
import { FadeUp } from "./FadeUp";
import { FREE_URL } from "../../lib/checkoutLinks";

const TRANSFORMATIONS = [
  {
    id: 1,
    name: "Vikram Singh",
    city: "Delhi",
    result: "-12 kg in 16 weeks",
    plan: "Fat Loss",
    img: "https://images.unsplash.com/photo-1682241367368-6387d5d4921a?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 2,
    name: "Sneha Kulkarni",
    city: "Pune",
    result: "+6 kg lean muscle in 5 months",
    plan: "Muscle Gain",
    img: "https://images.unsplash.com/photo-1683848644078-f339179c4ff6?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 3,
    name: "Arjun Nair",
    city: "Kochi",
    result: "-9 kg in 10 weeks",
    plan: "Fat Loss",
    img: "https://images.unsplash.com/photo-1632482151451-ccf4baf7f6a3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 4,
    name: "Riya Kapoor",
    city: "Chandigarh",
    result: "-8% body fat, fully toned",
    plan: "Fat Loss",
    img: "https://images.unsplash.com/photo-1541657333963-d31b55f58de1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 5,
    name: "Amit Verma",
    city: "Jaipur",
    result: "+8 kg muscle in 6 months",
    plan: "Muscle Gain",
    img: "https://images.unsplash.com/photo-1745851211804-409acbb4b597?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 6,
    name: "Neha Joshi",
    city: "Ahmedabad",
    result: "-14 kg in 20 weeks",
    plan: "Fat Loss",
    img: "https://images.pexels.com/photos/13534122/pexels-photo-13534122.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const Transformations = () => (
  <section id="transformations" className="py-14 md:py-20 px-6 bg-[#111113]">
    <div className="max-w-6xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-3">
          REAL TRANSFORMATIONS
        </h2>
        <p className="text-[#A1A1AA] text-center mb-10 max-w-xl mx-auto">
          10,000+ members changed their bodies with FORGE. Here are a few of them.
        </p>
      </FadeUp>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-10">
        {TRANSFORMATIONS.map((t, i) => (
          <FadeUp key={t.id} delay={i * 0.05}>
            <div
              data-testid={`transformation-card-${t.id}`}
              className="relative rounded-[24px] overflow-hidden h-72 group hover:-translate-y-1.5 transition-all duration-300 border border-[#232326]"
            >
              <img
                src={t.img}
                alt={`${t.name} from ${t.city}, FORGE transformation result: ${t.result}`}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute top-4 left-4 flex items-center gap-1 bg-black/50 rounded-full px-2.5 py-1">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={11} className="text-[#C6FF3D]" fill="#C6FF3D" />
                ))}
              </div>
              <span className="absolute top-4 right-4 bg-[#C6FF3D] text-black text-xs font-semibold px-3 py-1 rounded-full">
                {t.plan}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block bg-[#C6FF3D]/15 border border-[#C6FF3D]/30 text-[#C6FF3D] text-xs font-semibold px-3 py-1 rounded-full mb-2">
                  {t.result}
                </span>
                <p className="text-white font-semibold text-sm">{t.name}</p>
                <p className="text-[#d4d4d8] text-xs">{t.city}</p>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>

      <FadeUp className="flex justify-center">
        <a
          href={FREE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="transformations-cta"
          className="tap-target flex items-center justify-center bg-[#C6FF3D] text-black font-semibold px-8 py-3.5 rounded-full hover:scale-105 hover:shadow-[0_0_30px_rgba(198,255,61,0.5)] transition-all duration-300"
        >
          Start Your Transformation
        </a>
      </FadeUp>
    </div>
  </section>
);
